module.exports = __webpack_public_path__ + "img/02.bd871671.jpg";